import { render, staticRenderFns } from "./ComposicaoCustoTotalAbsoluto.vue?vue&type=template&id=9fa5dbf2&scoped=true&"
import script from "./ComposicaoCustoTotalAbsoluto.vue?vue&type=script&lang=js&"
export * from "./ComposicaoCustoTotalAbsoluto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fa5dbf2",
  null
  
)

export default component.exports